import styled from 'styled-components'

export const NavBtnPrimary = styled.div`
width: 300px;
font-size: 18px;
background-color: #62BCFA;
text-align: center;
color: white;
padding: 10px 20px;
`

export const NavBtnSecondary = styled.button`
width: 300px;
font-size: 18px;
border: 1px solid #62BCFA;
text-align: center;
color: white;
background-color: Transparent;
padding: 10px 20px;
`

export const BtnPrimary = styled.button`
color: white;
text-align: center;
background-color: #FA1A3B;
width: 400px;
font-size: 20px;
padding: 10px 0;
`

export const BtnSecondary = styled.button`
color: #FA1A3B;
border: 1px solid #FA1A3B;
text-align: center;
width: 400px;
font-size: 20px;
padding: 10px 0;
max-height: 50px;
margin: 0 auto;
display: block;
`


// WEBPACK FOOTER //
// ./src/components/button.jsx